import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EAddFavoriteActionTypes {
  Success = 'ADD_FAVORITE/SUCCESS',
}

interface IPayload {
  offerId: number;
}

type TAddFavoriteSuccess = ITypedReduxAction<EAddFavoriteActionTypes.Success, IPayload>;

export type TAddFavorite = TAddFavoriteSuccess;

export const addFavoriteSuccess = actionGenerator<EAddFavoriteActionTypes.Success, IPayload>(
  EAddFavoriteActionTypes.Success,
);
